import { Input, Component, OnInit, EventEmitter } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Company } from '@models/company.model';
import { Workflow, TaskDefinition } from '@models/workflow.model';
import { NgbPopoverConfig, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CompanyService } from '@services/company.service';
import { Toaster } from '@services/toaster.service';
import { LocalStorage } from 'ngx-webstorage';
import { EMPTY, of } from 'rxjs';
import * as moment from 'moment';
import { WorkflowCreationModalComponent } from '@app/modules/workflows/modals/workflow-creation-modal/workflow-creation-modal.component';

@Component({
  selector: 'ngx-workflow-detail',
  templateUrl: './workflow-detail.component.html',
  styleUrls: ['./workflow-detail.component.scss'],
})
export class WorkflowDetailComponent implements OnInit {

  @LocalStorage() organizationId: string;
  @LocalStorage() role: string;
  @LocalStorage() companyType: string;

  workflowId: string;
  workflow: Workflow;

  loading: boolean = false;

  workflowChangedEvent: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    config: NgbPopoverConfig,
    private $company: CompanyService,
    private $modal: NgbModal,
    private activatedRoute: ActivatedRoute,
    private toaster: Toaster,
    public location: Location,
    public router: Router,
  ) {
    config.placement = 'left';
    config.triggers = 'hover';
  }

  async ngOnInit() {
    if (!this.activatedRoute.snapshot.params.workflowId) {
      this.location.back();
      this.toaster.show('error', 'An error occurred', 'Please try again later');
    }
    this.workflowId = this.activatedRoute.snapshot.params.workflowId;
    this.getWorkflow();

    this.workflowChangedEvent.subscribe(e => {
      this.getWorkflow();
    });
  }

  openEditWorkflowModal() {
    const modalRef = this.$modal.open(WorkflowCreationModalComponent, {
      size: 'md',
      container: 'nb-layout',
    });
    modalRef.componentInstance.organizationId = this.organizationId;
    modalRef.componentInstance.workflow = this.workflow;
    modalRef.result.then((result) => {
      this.workflowChangedEvent.emit();
    }, (error) => {
      console.error(error);
    });
  }

  getWorkflow() {
    this.loading = true;
    this.$company.workflow(this.organizationId, this.workflowId)
      .subscribe((result) => {
        this.workflow = result;
        this.loading = false;
      });
  }

}
